export const DEFAULT_BOOKING_WINDOW_IN_DAYS = 180;
export const DEFAULT_EVENT_DURATION_IN_MINUTES = 1440;
export const DEFAULT_MAX_CONFLICT_INSTANCES = 0;
export const DEFAULT_ALLOWED_CONFLICT_PERCENTAGE = 0;

export const ALLOWED_OPTION_KEYS = ['ResourceScheduling'];
